 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML01_SERIES_PAGE from '@/components/xhtml/01_Series_Page'
 import XHTML04_EPIGRAPHS from '@/components/xhtml/04_Epigraphs'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_TRANSLATOR_S_NOTE from '@/components/xhtml/06_Translator_s_Note'
 import XHTML07_PREFATORY_NOTE from '@/components/xhtml/07_Prefatory_Note'
 import XHTML08_PROLOGUE from '@/components/xhtml/08_Prologue'
 import XHTML09_I__THE_USE_OF_BODIES from '@/components/xhtml/09_I__THE_USE_OF_BODIES'
 import XHTML10_1__THE_HUMAN_BEING_WITHOUT_WORK from '@/components/xhtml/10_1__The_Human_Being_without_Work'
 import XHTML11_2__CHRESIS from '@/components/xhtml/11_2__Chresis'
 import XHTML12_3__USE_AND_CARE from '@/components/xhtml/12_3__Use_and_Care'
 import XHTML13_4__THE_USE_OF_THE_WORLD from '@/components/xhtml/13_4__The_Use_of_the_World'
 import XHTML14_5__USE_OF_ONESELF from '@/components/xhtml/14_5__Use_of_Oneself'
 import XHTML15_6__HABITUAL_USE from '@/components/xhtml/15_6__Habitual_Use'
 import XHTML16_7__THE_ANIMATE_INSTRUMENT_AND_TE from '@/components/xhtml/16_7__The_Animate_Instrument_and_Te'
 import XHTML17_8__THE_INAPPROPRIABLE from '@/components/xhtml/17_8__The_Inappropriable'
 import XHTML18_INTERMEZZO_I from '@/components/xhtml/18_Intermezzo_I'
 import XHTML19_II__AN_ARCHEOLOGY_OF_ONTOLOGY from '@/components/xhtml/19_II__AN_ARCHEOLOGY_OF_ONTOLOGY'
 import XHTML20_1__ONTOLOGICAL_APPARATUS from '@/components/xhtml/20_1__Ontological_Apparatus'
 import XHTML21_2__THEORY_OF_HYPOSTASES from '@/components/xhtml/21_2__Theory_of_Hypostases'
 import XHTML22_3__TOWARD_A_MODAL_ONTOLOGY from '@/components/xhtml/22_3__Toward_a_Modal_Ontology'
 import XHTML23_INTERMEZZO_II from '@/components/xhtml/23_Intermezzo_II'
 import XHTML24_III__FORM_OF_LIFE from '@/components/xhtml/24_III__FORM_OF_LIFE'
 import XHTML25_1__LIFE_DIVIDED from '@/components/xhtml/25_1__Life_Divided'
 import XHTML26_2__A_LIFE_INSEPARABLE_FROM_ITS_F from '@/components/xhtml/26_2__A_Life_Inseparable_from_Its_F'
 import XHTML27_3__LIVING_CONTEMPLATION from '@/components/xhtml/27_3__Living_Contemplation'
 import XHTML28_4__LIFE_IS_A_FORM_GENERATED_BY_L from '@/components/xhtml/28_4__Life_Is_a_Form_Generated_by_L'
 import XHTML29_5__TOWARD_AN_ONTOLOGY_OF_STYLE from '@/components/xhtml/29_5__Toward_an_Ontology_of_Style'
 import XHTML30_6__EXILE_OF_ONE_ALONE_WITH_ONE_A from '@/components/xhtml/30_6__Exile_of_One_Alone_with_One_A'
 import XHTML31_7___THAT_S_HOW_WE_DO_IT from '@/components/xhtml/31_7___That_s_How_We_Do_It'
 import XHTML32_8__WORK_AND_INOPERATIVITY from '@/components/xhtml/32_8__Work_and_Inoperativity'
 import XHTML33_9__THE_MYTH_OF_ER from '@/components/xhtml/33_9__The_Myth_of_Er'
 import XHTML34_EPILOGUE__TOWARD_A_THEORY_OF_DES from '@/components/xhtml/34_Epilogue__Toward_a_Theory_of_Des'
 import XHTML35_BIBLIOGRAPHY from '@/components/xhtml/35_Bibliography'
 import XHTML36_SERIES_LIST from '@/components/xhtml/36_Series_List'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Translator_s_Note",
 			"name" : "xhtml/06_Translator_s_Note",
 			"component" : XHTML06_TRANSLATOR_S_NOTE
 		},
 		{
 			"path" : "/xhtml/07_Prefatory_Note",
 			"name" : "xhtml/07_Prefatory_Note",
 			"component" : XHTML07_PREFATORY_NOTE
 		},
 		{
 			"path" : "/xhtml/08_Prologue",
 			"name" : "xhtml/08_Prologue",
 			"component" : XHTML08_PROLOGUE
 		},
 		{
 			"path" : "/xhtml/09_I__THE_USE_OF_BODIES",
 			"name" : "xhtml/09_I__THE_USE_OF_BODIES",
 			"component" : XHTML09_I__THE_USE_OF_BODIES
 		},
 		{
 			"path" : "/xhtml/10_1__The_Human_Being_without_Work",
 			"name" : "xhtml/10_1__The_Human_Being_without_Work",
 			"component" : XHTML10_1__THE_HUMAN_BEING_WITHOUT_WORK
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js